import { render, staticRenderFns } from "./62.vue?vue&type=template&id=8f45b3c0&scoped=true&"
import script from "./62.vue?vue&type=script&lang=js&"
export * from "./62.vue?vue&type=script&lang=js&"
import style0 from "./62.vue?vue&type=style&index=0&id=8f45b3c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f45b3c0",
  null
  
)

export default component.exports